
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/s/[searchquery]",
      function () {
        return require("private-next-pages/[lang]/s/[searchquery].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/s/[searchquery]"])
      });
    }
  